import React from 'react';
import styles from './Navigation.module.scss';
import { menuData } from '../../../../contstants/menuData';

export default function Navigation(menuInfo) {
  return (
    <nav className={styles.navigation}>
      {menuInfo.menuInfo.map((item) => (
        <div key={item.id} className={styles.navigation_column}>
          <h3 className={styles.navigation_column_title}>{item.fields.title?.value}</h3>
          <ul className={styles.navigation_column_links}>
            {item.fields.Children.map((el) => (
              <li key={el.id} className={styles.navigation_column_links_item}>
                <a
                  href={`${el.fields?.Link?.value?.href || ''}${
                    el.fields?.Link?.value?.querystring || ''
                  }`}
                >
                  {el.fields.title.value}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
